import i18n from "@/plugins/vue-i18n";

export default {
  namespaced: true,

  state: {
    status: {
      planned: {
        text: i18n.t("promotions.status.planned"),
        color: "blue",
        value: "planned",
      },
      active: {
        text: i18n.t("promotions.status.active"),
        color: "green",
        value: "active",
      },
      completed: {
        text: i18n.t("promotions.status.completed"),
        color: "gray",
        value: "completed",
      },
      completed_early: {
        text: i18n.t("promotions.status.completedEarly"),
        color: "orange",
        value: "completed_early",
      },
    },
  },

  getters: {
    getStatuses(state) {
      return Object.values(state.status);
    },

    getStatusByValue(state) {
      return (status) => {
        if (!status) {
          return null;
        }

        const normalizedStatus = status.toLowerCase();

        return (
          state.status[normalizedStatus] || {
            text: status,
            color: "gray",
            value: status,
          }
        );
      };
    },
  },
};
